import axios from 'axios';

import { getAuthToken } from '@services/service';
import { Currency } from '@app-types/currency.type';

const BASE_URL = process.env.REACT_APP_PAYMENTS_URL as string;

const getCurrencies = async (): Promise<Currency[]> => {
    try {
        const response = await axios.get(
            `${BASE_URL}/api/admin/currency-config`,
            {
                headers: { Authorization: getAuthToken() },
            }
        );
        return response.data.data;
    } catch (err) {
        console.error('Error getting currencies:', err);
        return [];
    }
};

export { getCurrencies };
